import { debounce } from '../shared/functions';
import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', (): void => {
    const navbar = document.getElementById(constants.targets.menu.navbar);
    const documentElement = document.documentElement;
    const scrollThreshold = 10;

    if (!navbar) return;

    const isMobile = (): boolean => window.innerWidth <= constants.breakpoints.tablet;

    let lastScrollTop = 0;

    const handleScroll = (): void => {
        const currentScrollTop = window.scrollY;
        const scrollDiff = currentScrollTop - lastScrollTop;
        const scrollingUp = scrollDiff < -scrollThreshold;
        const scrollingDown = scrollDiff > scrollThreshold;
        const atBottom = window.innerHeight + currentScrollTop >= document.documentElement.scrollHeight - 1;

        if (currentScrollTop === 0) {
            documentElement.classList.add(constants.classes.stuck);
        } else {
            documentElement.classList.remove(constants.classes.stuck);
        }

        if (isMobile()) {
            if (!atBottom && scrollingUp) {
                navbar.classList.add(constants.classes.fixedTop);
                documentElement.classList.add(constants.classes.navbarFixedTop);
            } else if (scrollingDown || atBottom) {
                navbar.classList.remove(constants.classes.fixedTop);
                documentElement.classList.remove(constants.classes.navbarFixedTop);
            } else {
                navbar.classList.add(constants.classes.fixedTop);
                documentElement.classList.add(constants.classes.navbarFixedTop);
            }
        } else {
            navbar.classList.add(constants.classes.fixedTop);
            documentElement.classList.add(constants.classes.navbarFixedTop);
        }

        lastScrollTop = currentScrollTop;
    };

    const debouncedHandleScroll = debounce(handleScroll, 50);

    document.addEventListener('scroll', debouncedHandleScroll);
    window.addEventListener('resize', debouncedHandleScroll);

    handleScroll();
});
